module.exports = __webpack_public_path__ + "static/media/astro_sales_commerce.0e7dd120.png";